var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTitleDigi3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3{fill:#b0ffd7;}.cls-2,.cls-4{mix-blend-mode:screen;}.cls-3{opacity:0;}.cls-5{isolation:isolate;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    width: 200,
    height: 200
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 120.23,
    cy: 104.13,
    r: 68.36
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M89.96,121.5c0,14.13,11.46,25.59,25.59,25.59s25.59-11.46,25.59-25.59h-51.18Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 79.67,
    y: 87.75,
    width: 26.93,
    height: 20.05,
    rx: 10.02,
    ry: 10.02,
    transform: "translate(190.9 4.63) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 125.69,
    y: 87.75,
    width: 26.93,
    height: 20.05,
    rx: 10.02,
    ry: 10.02,
    transform: "translate(236.93 -41.39) rotate(90)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 12.68,
    y: 32.39,
    width: 78.37,
    height: 49.92,
    rx: 9.27,
    ry: 9.27
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44.81,82.31v14.63c0,2.21-2.67,3.32-4.24,1.76l-16.33-16.33,20.57-.06Z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTitleDigi3);
export default __webpack_public_path__ + "static/media/title-digi-3.8d2d0f8442c90cfdb9db0a91c3b50d39.svg";
export { ForwardRef as ReactComponent };